export const CANCELLED_STATUSES = [
  'Cancelled',
  'cancelled',
  'CANCELLED',
  'canceled',
]

// ── How long a pause counts as "done typing" ────────────────────────────────
// The transfer surfaces search as the user types, so one flight number used to be several
// lookups: "BA830" also arrives as BA8 and BA83, and every one of those passes the
// completeness gate and costs a full resolution upstream. A person typing a flight number
// does not pause for this long mid-number, but does pause after finishing it — so the
// prefixes collapse into the single search that was actually intended.
//
// Paired with a flush on blur (FormFieldFlights): tabbing out of the field searches
// immediately, so waiting longer never makes the UI feel slower when the user has clearly
// finished. The VIP surfaces already work this way — they search on a button.
export const FLIGHT_SEARCH_PAUSE_MS = 1800

// RD-4073: how long a standalone-VIP flight lookup may run before the field gives up and reads
// "Flight not verified". The admin booking page already uses 25s for the same purpose; the
// lookup is a sequence of calls (booked day, previous/next-day retries, route), each several
// seconds, so a flight the supplier cannot answer otherwise keeps the spinner up for as long as
// the whole ladder takes.
export const FLIGHT_LOOKUP_CEILING_MS = 25000
